import { useEffect, useState } from 'react';
import { api } from '../api/client.ts';
import type { Periode } from './Accueil.tsx';

const LIBELLES: Record<string, string> = {
  totalCE: 'Total CE',
  ceMoins5ans: 'CE moins de 5 ans',
  ce5ansEtPlus: 'CE 5 ans et plus',
  totalFievre: 'Total fièvre',
  fievreMoins5ans: 'Fièvre moins de 5 ans',
  fievre5ansEtPlus: 'Fièvre 5 ans et +',
  totalPaludisme: 'Total paludisme',
  paludismeMoins5ans: 'Paludisme moins de 5 ans',
  paludisme5ansEtPlus: 'Paludisme 5 ans et plus',
  totalPaludismeSimple: 'Total paludisme simple',
  paludismeSimpleMoins5ans: 'Paludisme simple moins de 5 ans',
  paludismeSimple5ansEtPlus: 'Paludisme simple 5 ans et plus',
  totalPaludismeGrave: 'Total paludisme grave',
  paludismeGraveMoins5ans: 'Paludisme grave moins de 5 ans',
  paludismeGrave5ansEtPlus: 'Paludisme grave 5 ans et plus',
  infectionRespiratoire: 'Infection respiratoire',
  pneumonie: 'Pneumonie',
  diarrheeMoins5ans: 'Diarrhée moins de 5 ans',
  diarrhee5ansEtPlus: 'Diarrhée 5 ans et plus',
  dysenterie: 'Dysenterie',
  sdGrippal: 'Sd grippal',
  mas: 'MAS',
  mam: 'MAM',
  admis: 'Admis',
  guerie: 'Guérie',
};

export default function TableauSuivi({ periode }: { periode: Periode | null }) {
  const [suivi, setSuivi] = useState<Record<string, number> | null>(null);

  useEffect(() => {
    if (periode) {
      api.get<any>(`/rma/${periode.id}`).then((r) => setSuivi(r.tableauSuivi));
    }
  }, [periode?.id]);

  if (!periode) return <p>Sélectionnez d'abord une période sur l'écran Accueil.</p>;
  if (!suivi) return <p>Chargement…</p>;

  return (
    <div>
      <h1>Tableau de suivi — {periode.mois}/{periode.annee}</h1>
      <table>
        <tbody>
          {Object.entries(LIBELLES).map(([cle, libelle]) => (
            <tr key={cle}><td>{libelle}</td><td><strong>{suivi[cle] ?? 0}</strong></td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
